import React from 'react';
import './ExtractionList.css';
import ExtractionListItem from './ExtractionListItem';

const ExtractionList = ({ 
  extractions, 
  currentExtractionId, 
  onSelectExtraction,
  formatTimestamp,
  getStatusLabel,
  getStatusClass
}) => {
  if (extractions.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📋</div>
        <p>Nenhuma extração ainda</p>
        <span>Faça upload de arquivos ou digite um texto para começar</span>
      </div>
    );
  }

  return (
    <div className="extraction-list">
      {extractions.map((extraction) => (
        <ExtractionListItem
          key={extraction.id}
          extraction={extraction}
          isActive={currentExtractionId === extraction.id}
          onSelect={onSelectExtraction}
          formatTimestamp={formatTimestamp}
          getStatusLabel={getStatusLabel}
          getStatusClass={getStatusClass}
        />
      ))}
    </div>
  );
};

export default ExtractionList;
